import { render, staticRenderFns } from "./oauth-grant-access.vue?vue&type=template&id=62530462"
import script from "./oauth-grant-access.vue?vue&type=script&lang=js"
export * from "./oauth-grant-access.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports